export const ERROR_CODES = {
    402:'El correo electrónico ya está en uso',
    106:'Correo y/o contraseña incorrectos',
    403:'Usuario no confirmado'
}